export const environment = {
  production: false,
  name: 'dev',
  backendUrl: 'https://api.streaks.dev.splash.tech/api/game',
  bridgeUrl: 'https://api.streaks.dev.splash.tech/bridge',
  quizFrontendUrl: 'https://quiz-dev.splash.tech',
  loaderAssetsUrl: 'https://loader-dev.splash.tech',
};
